"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIDDING_CORRECTION_WRITE_ROLES = exports.BIDDING_WFM_WRITE_ROLES = exports.BIDDING_MANAGER_READ_ROLES = exports.BIDDING_READ_ROLES = void 0;
const Roles_1 = require("../enums/Roles");
exports.BIDDING_READ_ROLES = [Roles_1.Roles.CallmartOSP, Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartWTM];
// Manager + stakeholder bidding dashboards (Übersicht, Offered, Offered Cluster, Calculated).
exports.BIDDING_MANAGER_READ_ROLES = [Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartWTM];
// WFM-authoritative bidding writes: strategic numbers, calculated results, release/force operations.
exports.BIDDING_WFM_WRITE_ROLES = [Roles_1.Roles.CallmartWFM];
// OSP authors their own corrections; WFM confirms them.
exports.BIDDING_CORRECTION_WRITE_ROLES = [Roles_1.Roles.CallmartOSP, Roles_1.Roles.CallmartWFM];
